import { useEffect, useState } from 'react';

/*
 * Înregistrează service workerul PWA și oferă un update UX controlat de user.
 *
 * - Prima instalare (fără controller existent) se activează silențios.
 * - La un worker nou „waiting" (există deja un controller) → afișăm un toast
 *   discret „Versiune nouă → Reîncarcă". La click trimitem SKIP_WAITING; când
 *   noul worker preia controlul (controllerchange) reîncărcăm o singură dată.
 *
 * Randează doar în producție (SW-ul e înregistrat doar acolo — vezi condiția).
 */
const PwaManager = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') {
      return;
    }

    let reloading = false;
    const onControllerChange = () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

    const promptForWorker = (worker) => {
      // Dacă nu există controller, e prima instalare → nimic de înlocuit.
      if (worker && navigator.serviceWorker.controller) {
        setWaitingWorker(worker);
      }
    };

    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        if (reg.waiting) promptForWorker(reg.waiting);

        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed') promptForWorker(installing);
          });
        });
      })
      .catch(() => {});

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    };
  }, []);

  const applyUpdate = () => {
    if (waitingWorker) waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    setWaitingWorker(null);
  };

  if (!waitingWorker) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: 'calc(16px + env(safe-area-inset-bottom))',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        maxWidth: '92vw',
        background: '#124461',
        color: '#fff',
        padding: '12px 16px',
        borderRadius: '12px',
        boxShadow: '0 6px 24px rgba(0,0,0,.28)',
        fontSize: '14px',
      }}
    >
      <span>E disponibilă o versiune nouă.</span>
      <button
        type="button"
        onClick={applyUpdate}
        style={{
          appearance: 'none',
          border: 0,
          cursor: 'pointer',
          background: '#fff',
          color: '#124461',
          fontWeight: 600,
          fontSize: '14px',
          padding: '7px 16px',
          borderRadius: '999px',
        }}
      >
        Reîncarcă
      </button>
    </div>
  );
};

export default PwaManager;
